module.exports = __webpack_public_path__ + "img/user.28959ca3.svg";